import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import exportEventsStore from 'store/ExportEventsStore';
import commonStore from 'store/CommonStore';
import { EventsFilters } from 'types';
import { debounce, isEqual } from 'lodash';
import { DEBOUNCE_WAIT, GLUCOMETER_SERIAL_NUMBER } from 'consts';

const isTextFilterNeedFetch = (
  filterName: string,
  value: object | string | number | null,
  minLength: number = 2,
  maxLength: number = 999,
) =>
  ((filterName === 'emailPatterns' ||
    filterName === 'glucometerSerialNumbers') &&
    typeof value === 'string' &&
    (value.length === 0 ||
      (value.length > minLength && value.length < maxLength))) ||
  typeof value === 'number';

type FilterNameType = keyof Pick<
  EventsFilters,
  | 'eventTypes'
  | 'groups'
  | 'tags'
  | 'emailPatterns'
  | 'glucometerSerialNumbers'
  | 'glucoseValueMoreThen'
  | 'glucoseValueLessThen'
>;

type Props = {
  setFilters: Dispatch<any>;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  setRows: Dispatch<SetStateAction<number>>;
  filters: EventsFilters;
};

const ExportEventsFilters: FC<Props> = ({
  setFilters,
  setCurrentPage,
  setRows,
  filters,
}) => {
  // const [eventTypeOptions, setEventTypeOptions] = useState<OptionType[]>([]);
  // const [eventDate, setEventDate] = useState<Date | Date[] | undefined>(
  //   undefined,
  // );

  useEffect(() => {
    commonStore.fetchEventTypes().then(() => {
      // setEventTypeOptions(
      //   commonStore.eventTypes.map((eventType) => ({
      //     label: eventType,
      //     value: eventType,
      //   })),
      // );
    });
  }, []);

  const setFirstPage = () => {
    setRows(1);
    setCurrentPage(0);
  };

  const handleFilterChange = (
    value: object | string | number | null,
    filterName: FilterNameType,
  ) => {
    const currentValue = filters[filterName];
    if (
      isEqual(currentValue, value) ||
      (currentValue == null && value == null)
    ) {
      return;
    }
    if (
      (filterName === 'emailPatterns' &&
        isTextFilterNeedFetch(filterName, value)) ||
      (filterName === 'glucometerSerialNumbers' &&
        isTextFilterNeedFetch(filterName, value, 0, 12)) ||
      (filterName !== 'emailPatterns' &&
        filterName !== 'glucometerSerialNumbers')
    ) {
      const newFilter = { ...filters, [filterName]: value };
      setFilters(newFilter);
      exportEventsStore.fetchEvents({
        page: 1,
        size: 10,
        ...newFilter,
      });
      setFirstPage();
    }
  };

  // const handleDateChange = (e: CalendarChangeParams) => {
  //   const { dates } = prepareDataForDateRangeFilter(e);
  //   setEventDate(dates);

  //   if (!dates) {
  //     const newFilter = {
  //       ...filters,
  //       unloadDateFrom: undefined,
  //       unloadDateTo: undefined,
  //     };
  //     setFilters(newFilter);
  //     exportEventsStore.fetchEvents({
  //       page: 1,
  //       size: 10,
  //       ...newFilter,
  //     });
  //     setFirstPage();
  //     return;
  //   }

  //   const [fromDate, toDate] = dates;
  //   if (toDate) {
  //     const newFilter = {
  //       ...filters,
  //       unloadDateFrom: `${format(fromDate, 'yyyy-MM-dd')}T00:00:00.000Z`,
  //       unloadDateTo: `${format(toDate, 'yyyy-MM-dd')}T00:00:00.000Z`,
  //     };
  //     setFilters(newFilter);
  //     exportEventsStore.fetchEvents({
  //       page: 1,
  //       size: 10,
  //       ...newFilter,
  //     });
  //     setFirstPage();
  //   }
  // };

  const debounceEmail = debounce(
    (e) => handleFilterChange(e.target.value, 'emailPatterns'),
    DEBOUNCE_WAIT,
  );

  const debounceGlucometerSerialNumber = debounce(
    (e) => handleFilterChange(e.target.value, 'glucometerSerialNumbers'),
    DEBOUNCE_WAIT,
  );

  const debounceGlucoseValueMoreThen = debounce(
    (e) => handleFilterChange(e.value, 'glucoseValueMoreThen'),
    DEBOUNCE_WAIT,
  );

  const debounceGlucoseValueLessThen = debounce(
    (e) => handleFilterChange(e.value, 'glucoseValueLessThen'),
    DEBOUNCE_WAIT,
  );

  return (
    <div className="flex flex-wrap gap-3 mb-3">
      {/* <MultiSelect
        placeholder="Тип события"
        display="chip"
        options={eventTypeOptions}
        onChange={(e) => handleFilterChange(e.value, 'eventTypes')}
        value={exportEventsStore.filters.eventTypes}
      /> */}
      {/* <Calendar
        value={eventDate}
        placeholder="Дата добавления"
        onChange={handleDateChange}
        dateFormat="dd/mm/yy"
        selectionMode="range"
        readOnlyInput
        showButtonBar
        showIcon
      /> */}
      <InputText
        placeholder="Email"
        onInput={(e) => debounceEmail(e)}
        style={{ width: '20%' }}
      />
      <InputText
        placeholder="Серийный номер глюкометра"
        onInput={(e) => debounceGlucometerSerialNumber(e)}
        keyfilter="pnum"
        maxLength={GLUCOMETER_SERIAL_NUMBER}
        style={{ width: '20%' }}
      />
      <InputNumber
        placeholder="Значение глюкозы >="
        onValueChange={(e) => debounceGlucoseValueMoreThen(e)}
        style={{ width: '15%' }}
        mode="decimal"
        minFractionDigits={1}
        maxFractionDigits={1}
        useGrouping={false}
      />
      <InputNumber
        placeholder="Значение глюкозы <="
        onValueChange={(e) => debounceGlucoseValueLessThen(e)}
        style={{ width: '15%' }}
        mode="decimal"
        minFractionDigits={1}
        maxFractionDigits={1}
        useGrouping={false}
      />
    </div>
  );
};

export default ExportEventsFilters;
